import { Button, Typography, styledComponent } from '@hermes/web-components'

export const ModalButton = styledComponent(Button)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.neutral[200]}`
}))

export const TextContent = styledComponent(Typography)(() => ({
  li: {
    paddingBottom: '20px'
  }
}))

export const BulletTitle = styledComponent(Typography)(() => ({
  fontWeight: 500,
  paddingBottom: '4px'
}))
